import React, { useEffect, useState } from "react";
import { Button, Drawer, Input, Space, Tag, message } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import CustomTable from "../../components/Table/CustomTable";
import ProductSettingForm from "./ProductSettingForm";
import API from "../../api";
import { setProductSetting } from "../../redux/slices/productSettingSlice";
import { useDispatch } from "react-redux";

export default function ProductSetting() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({ search: "" });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [user, setUser] = useState({});

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    setUser(userData);
  }, []);

  const fetchSettings = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const payload =
        userData?.role === "admin" ? {} : { storeId: userData?.storeId };

      const res = await API.post("/product/setting/get", payload);
      const formatted = res.data.map((item) => ({
        _id: item._id,
        storeId: item.storeId._id,
        storeName: item.storeId.name,
        mfg_exp: item.mfg_exp ? "Yes" : "No",
        size: item.size ? "Yes" : "No",
        engineNumber: item.trackingNumber ? "Yes" : "No",
        batchNumber: item.batchNumber ? "Yes" : "No",
      }));
      setData(formatted);
      dispatch(setProductSetting(formatted));
    } catch (err) {
      message.error("Failed to fetch product settings");
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
    let result = [...data];
    if (filters.search) {
      result = result.filter((item) =>
        item.storeName.toLowerCase().includes(filters.search.toLowerCase())
      );
    }
    const paginated = result.slice(
      (pagination.current - 1) * pagination.pageSize,
      pagination.current * pagination.pageSize
    );
    setFilteredData(paginated);
  }, [filters, pagination.current, pagination.pageSize, data]);

  useEffect(() => {
    let result = [...data];
    if (filters.search) {
      result = result.filter((item) =>
        item.storeName.toLowerCase().includes(filters.search.toLowerCase())
      );
    }
    setPagination((prev) => ({
      ...prev,
      total: result.length,
    }));
  }, [filters, data]);

  const columns = [
    { title: "Store Name", dataIndex: "storeName" },
    // {
    //   title: "Manufacturing & Expiry",
    //   dataIndex: "mfg_exp",
    //   render: (value) => (
    //     <Tag color={value === "Yes" ? "green" : "red"}>{value}</Tag>
    //   ),
    // },
    // {
    //   title: "Size",
    //   dataIndex: "size",
    //   render: (value) => (
    //     <Tag color={value === "Yes" ? "green" : "red"}>{value}</Tag>
    //   ),
    // },
    {
      title: "Tracking Number/Eng-No",
      dataIndex: "engineNumber",
      render: (value) => (
        <Tag color={value === "Yes" ? "green" : "red"}>{value}</Tag>
      ),
    },
    {
      title: "Batch Number",
      dataIndex: "batchNumber",
      render: (value) => (
        <Tag color={value === "Yes" ? "green" : "red"}>{value}</Tag>
      ),
    },
  ];

  return (
    <div
      style={{
        padding: "20px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Space>
          <Input
            placeholder="Search by store name"
            style={{ width: 300 }}
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            prefix={<SearchOutlined />}
          />
        </Space>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setIsDrawerOpen(true)}
        >
          Add Product Setting
        </Button>
      </div>

      <CustomTable
        columns={columns}
        dataSource={filteredData}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          onChange: (page, pageSize) =>
            setPagination((prev) => ({
              ...prev,
              current: page,
              pageSize,
            })),
        }}
        rowKey="_id"
      />

      <Drawer
        title="Add Product Setting"
        width={400}
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        destroyOnClose
      >
        <ProductSettingForm
          setIsDrawerOpen={setIsDrawerOpen}
          fetchSettings={fetchSettings}
        />
      </Drawer>
    </div>
  );
}
